import { createTheme } from "@mui/material/styles";
import type {} from "@mui/x-data-grid/themeAugmentation";

const customDataGridStyle = {
  MuiDataGrid: {
    styleOverrides: {
      root: {
        border: "none",
      },
      columnHeader: {
        color: "darkGrey",
        "text-transform": "uppercase",
        "font-size": ".8rem",
      },
      virtualScroller: {
        minHeight: "100px",
      },
    },
  },
};

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#f2b443",
    },
    secondary: {
      main: "#78c0a1",
    },
    text: {
      primary: "#ffffff",
      secondary: "#c7c7c7",
    },
    background: {
      default: "#000000",
      paper: "#1e1e1e",
    },
    action: {
      active: "#34c1d6",
      disabled: "#555555",
    },
    success: {
      main: "#4bc54f",
    },
    error: {
      main: "#FF6F61",
      light: "rgba(255, 111, 97, 0.7)",
      dark: "#D1564D",
      contrastText: "#FFFFFF",
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
  typography: {
    fontFamily: "Roboto, sans-serif",
    h1: {
      color: "#ffffff", // Set h1 headers to white
    },
    h2: {
      color: "#ffffff", // Set h2 headers to white
    },
    h3: {
      color: "#ffffff", // Set h3 headers to white
    },
    h4: {
      color: "#ffffff", // Set h4 headers to white
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& input:-webkit-autofill": {
            backgroundColor: "transparent !important",
            WebkitBoxShadow: "0 0 0px 1000px #0A1929 inset !important",
            WebkitTextFillColor: "#fff !important",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "none",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#f2b443",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "none",
          },
        },
        input: {
          borderRadius: "8px",
          backgroundColor: "#0A1929",
          color: "rgba(255, 255, 255, 0.87)",
        },
      },
    },
    ...customDataGridStyle,
  },
});
